import { type TableInformation } from '../../../config/flavourConfig';
import { type CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { type PrivateContentDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/content';
import ViewHippoInformationModal from '../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import { convertAmountDtoToString } from '../../../utils/currencyUtil';

export const getCoverableDetailsLimitedSumsConfig = (
    coverable: CoverableDTO
): TableInformation | undefined => {
    switch (coverable.flavourName) {
        case 'Indboforsikring':
            return getContentLimitedSumsConfig(coverable);
        default:
            return undefined;
    }
};

const getContentLimitedSumsConfig = (coverable: PrivateContentDTO): TableInformation => {
    return {
        title: 'Steder med begrænsede forsikringssummer',
        subtitle:
            'Vær opmærksom på, at der i vilkårene kan være flere begrænsninger for visse kategorier af ting, skadeårsager eller steder.',
        rowsInformation: [
            {
                name: 'Kælder i bolig (hus eller rækkehus)',
                subtext: [
                    {
                        title: 'ved nedbørsskade',
                        value: coverable.basementPercipitationSum
                    }
                ],
                hidden: coverable.buildingType === 'ApartmentType'
            },
            {
                name: 'Loft og kælderrum',
                subtext: [
                    {
                        title: 'ved indbrudstyveri, hærværk eller nedbørsskade',
                        value: convertAmountDtoToString(coverable.apartmentLoftBasementBurglarySum)
                    },
                    {
                        title: 'ved simpelt tyveri',
                        value: convertAmountDtoToString(
                            coverable.apartmentLoftBasementSimpleTheftSum
                        ),
                        isTitleInteractive: true,
                        modalInformation: {
                            modalType: ViewHippoInformationModal,
                            modalProps: {
                                title: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-THEFT-TITLE',
                                description:
                                    'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-THEFT-DESCRIPTION'
                            }
                        }
                    }
                ],
                hidden: coverable.buildingType !== 'ApartmentType'
            },
            {
                name: 'Udhus og garager',
                subtext: [
                    {
                        title: 'ved indbrudstyveri eller hærværk',
                        value: coverable.outhouseAndGarageBurglaryVandal
                    },
                    {
                        title: 'ved simpelt tyveri',
                        value: coverable.outhouseAndGarageSimpleTheftSum,
                        isTitleInteractive: true,
                        modalInformation: {
                            modalType: ViewHippoInformationModal,
                            modalProps: {
                                title: 'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-THEFT-TITLE',
                                description:
                                    'DSS-CON-ADULT-HIGHLIGHTED-TEXT-MODAL-THEFT-DESCRIPTION'
                            }
                        }
                    }
                ]
            },
            {
                name: 'Uden for bygning eller fra uaflåst bygning, lokale eller godkendt container',
                fieldValue: coverable.outhouseAndGarageBurglaryVandal,
                subtext: [
                    {
                        title: `${'ved simpelt tyveri af særlig værdifuldt indbo'}
                        ${' (fx bærbar elektronik, musikinstrumenter, kunstværker, spiritus og våben)'}`,
                        value: coverable.outhouseBuildingContainerSimpleTheft
                    }
                ]
            }
        ]
    };
};
